// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VideoStatusDescription {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #4c5567;
  color: var(--color_neutral_800, #4c5567);
}
.VideoStatusDescription [aria-describedby^=tooltip] {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #4c5567;
  color: var(--color_neutral_800, #4c5567);
}
.VideoStatusDescription__separator {
  display: flex;
  align-items: center;
  justify-content: center;
  color: currentColor;
  font-size: 4px;
  order: 1;
}
.VideoStatusDescription .VideoIconStatus {
  order: 3;
  display: flex;
  align-items: center;
}
.VideoStatusDescription__text {
  display: flex;
  align-items: center;
  white-space: nowrap;
  font-size: 14px;
  order: 2;
  margin: 0;
}
.VideoStatusDescription--has-status .VideoIconStatus {
  order: 2;
}
.VideoStatusDescription--has-status .VideoStatusDescription__text {
  order: 3;
}
.VideoStatusDescription--success .VideoStatusDescription__text {
  color: var(--color_neutral_500);
}`, "",{"version":3,"sources":["webpack://./src/modules/posts/video-status-description/video-status-description.styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EAAA,wCAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EAAA,wCAAA;AACJ;AAEE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,QAAA;AAAJ;AAGE;EACE,QAAA;EACA,aAAA;EACA,mBAAA;AADJ;AAIE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;AAFJ;AAMI;EACE,QAAA;AAJN;AAOI;EACE,QAAA;AALN;AAUI;EACE,+BAAA;AARN","sourcesContent":[".VideoStatusDescription {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--color_neutral_800, #4c5567);\n\n  [aria-describedby^='tooltip'] {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    color: var(--color_neutral_800, #4c5567);\n  }\n\n  &__separator {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: currentColor;\n    font-size: 4px;\n    order: 1;\n  }\n\n  .VideoIconStatus {\n    order: 3;\n    display: flex;\n    align-items: center;\n  }\n\n  &__text {\n    display: flex;\n    align-items: center;\n    white-space: nowrap;\n    font-size: 14px;\n    order: 2;\n    margin: 0;\n  }\n\n  &--has-status {\n    .VideoIconStatus {\n      order: 2;\n    }\n\n    .VideoStatusDescription__text {\n      order: 3;\n    }\n  }\n\n  &--success {\n    .VideoStatusDescription__text {\n      color: var(--color_neutral_500);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
